import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout/Layout";
import AuthInterceptor from "./components/AuthInterceptor";

import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads.jsx";
import Clients from "./pages/Clients.jsx";
import Bookings from "./pages/Bookings";
import Itineraries from "./pages/Itineraries";
import Packages from "./pages/Packages";
import Analytics from "./pages/Analytics";
import LeadDetail from "./pages/LeadDetail.jsx";
import Agents from "./pages/Agents";
import Vendors from "./pages/Vendors"; // ← NEW
import SignIn from "./pages/auth/SignIn";
import CreateUser from "./pages/auth/CreateUser";
import ViewItinerary from "./pages/ViewItinerary.jsx";
import EditItinerary from "./pages/EditItinerary.jsx";


/* 🔐 Route Guard */
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const user  = localStorage.getItem("authUser");

  if (!token || !user) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    return <Navigate to="/signin" replace />;
  }

  try {
    JSON.parse(user);
    return children;
  } catch (error) {
    console.error("Error parsing user data:", error);
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    return <Navigate to="/signin" replace />;
  }
};

/* 🔓 Public Route */
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const user  = localStorage.getItem("authUser");
  if (token && user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthInterceptor />

      <Routes>
        {/* 🔓 Public Routes */}
        <Route path="/signin" element={<PublicRoute><SignIn /></PublicRoute>} />
        <Route path="/create-user" element={<PublicRoute><CreateUser /></PublicRoute>} />

        {/* 🔐 Protected Routes */}
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard"   element={<Dashboard />} />
          <Route path="leads"       element={<Leads />} />
          <Route path="leads/:id"   element={<LeadDetail />} />
          <Route path="clients"     element={<Clients />} />
          <Route path="bookings"    element={<Bookings />} />
          <Route path="agents"      element={<Agents />} />
          <Route path="vendors"     element={<Vendors />} /> {/* ← NEW */}
          <Route path="itineraries" element={<Itineraries />} />
          <Route path="packages"    element={<Packages />} />
          <Route path="analytics"   element={<Analytics />} />
          <Route path="settings"    element={<div>Settings Page</div>} />
          <Route path="help"        element={<div>Help & Support Page</div>} />
          <Route path="/itineraries/:id"      element={<ViewItinerary />} />
          <Route path="/itineraries/:id/edit" element={<EditItinerary />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;